import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'antd'

import motivationalPhrases from '/utils/motivationalPhrases.json'
import './index.less'

const BANNER_URL = 'https://gcmgames-static.s3.amazonaws.com/img/banner.jpg'
const REDIRECT_URL = 'https://www.gcmgames.com.br'

export const Advertising = memo(({ isVisible, handleCancel }) => {
  const Title = () => {
    const phrase =
      motivationalPhrases[
        Math.floor(Math.random() * motivationalPhrases.length)
      ]
    return <div id='title-header'>{phrase}</div>
  }
  const CloseIcon = () => <span id='close-icon'>X</span>

  return isVisible ? (
    <Modal
      title={<Title />}
      width={800}
      visible={isVisible}
      footer={null}
      closeIcon={<CloseIcon />}
      onCancel={handleCancel}
      style={{ textAlign: 'center' }}
    >
      <a href={REDIRECT_URL} target='_blank' rel='noopener noreferrer'>
        <img src={BANNER_URL} style={{ maxWidth: '100%', padding: 10 }} />
      </a>
    </Modal>
  ) : null
})

Advertising.displayName = 'Advertising'

Advertising.propTypes = {
  /** Whether the Modal is visible or not */
  isVisible: PropTypes.bool.isRequired,

  /** Callback to be executed when the Modal is closed */
  handleCancel: PropTypes.func.isRequired,
}
